const getRunningBrowserOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.includes('macintosh')) return 'macOS';
  if (userAgent.includes('windows') || userAgent.includes('linux')) return 'windows';
};

export default getRunningBrowserOS;
